import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableForgotPassword = withAsyncLoading(async () =>
    import('./ForgotPasswordPage').then((res) => res.ForgotPasswordPage)
);

export { LoadableForgotPassword };
